import React, { Component, Fragment } from "react";
import moment from "moment";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Creators as ReportsActions,
  Selectors as ReportsSelectors,
} from "store/ducks/reports";

import { Access } from "common";
import { Page, Breadcrumbs, Panel, Loading } from "components";
import { Filters } from "./components";
import { Info } from "./components/infoIcon";

const INITIAL_STATE = {
  date_start: null,
  date_end: null,
  date_formatted: "",
  place_formatted: "Todas",
  plans: [],
};

class Benefits extends Component {
  state = {
    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "Relatórios", to: "/reports" },
      { name: "Relatório de Pontos e Vouchers(Vale Troca)", to: "" },
    ],
    filter: {
      ...INITIAL_STATE,
      place_ids: Access.lockedStore()
        ? [Access.lockedStore(true)]
        : [],
    },
  };

  componentDidMount() {
    const { getReportPointsRequest } = this.props;

    getReportPointsRequest(this.state.filter);
  }

  componentDidUpdate(oldProps, oldState) {
    const { filter } = this.state;

    if (
      oldState.filter.date_start !== filter.date_start ||
      oldState.filter.date_end !== filter.date_end
    ) {
      const date_formatted = filter.date_start
        ? `${
            filter.date_start !== null
              ? moment(filter.date_start).format("DD/MM/YYYY")
              : ""
          } ${filter.date_end !== null ? "-" : ""} ${
            filter.date_end !== null
              ? moment(filter.date_end).format("DD/MM/YYYY")
              : ""
          }`
        : "";

      this.setState({ filter: { ...filter, date_formatted } });
    }

    if (oldState.filter.place_ids !== filter.place_ids) {
      const place_formatted = filter.place_ids
      .map((store) => `${store.label}`)
       .join(", ");

      this.setState({ filter: { ...filter, place_formatted: place_formatted || "Todas" } });
    }
  }

  handleChangeFilter = async (name, value) => {
    const { filter } = this.state;
    const { getReportPointsRequest } = this.props;

    this.setState({ filter: { ...filter, [name]: value } }, () => {
      getReportPointsRequest(this.state.filter);
    });
  };

  handleCleanFilter = async (e) => {
    e.preventDefault();

    const newState = {
      filter: {
        ...INITIAL_STATE,
        place_ids: Access.lockedStore()
          ? [Access.lockedStore(true)]
          : [],
      },
    };

    this.setState(newState/*, () => {
      getReportPointsRequest(this.state.filter);
    }*/);
  };

  handleExport = async (name, value) => {
    const { filter } = this.state;
    const { exportReportPointsRequest } = this.props;

    this.setState({ filter: { ...filter, [name]: value } }, () => {
      exportReportPointsRequest(this.state.filter);
    });
  };

  render() {
    const { breadcrumbs, filter } = this.state;
    const { report } = this.props;

    return (
      <Page className="page-reports">
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <header className="page-reports-header">
          <Page.Title>Relatório de Pontos e Vouchers(Vale Troca)</Page.Title>

          <Filters
            data={filter}
            onChange={this.handleChangeFilter}
            onClean={this.handleCleanFilter}
          />
        </header>

        <Panel className="panel-list">
          <Fragment>
            {report.loading && <Loading type="table" size="x-large" />}

            {filter.date_formatted !== "" && (
              <Panel.Title>
                Período: <span>{filter.date_formatted}</span>
              </Panel.Title>
            )}

            {filter.place_formatted !== "" && (
              <Panel.Title>
                Loja: <span>{filter.place_formatted}</span>
              </Panel.Title>
            )}

            <h5>Relatório de Pontos e Vouchers(Vale Troca)</h5>

            <table className="contact-table table table-curved table-striped">
              <thead>
                <tr>
                  <th>Pontos</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="icon-info" > Pontos distribuídos (+)

                  <Info info='Soma de todos os pontos positivos.
                              Referente a lançamentos manuais, Objetivo alcançado,  compras realizadas por um cliente.'/></td>

                  <td className="number-report">
                    {report.data.generated_points}
                  </td>
                </tr>

                <tr>
                  <td className="icon-info" > Pontos utilizados voucher moeda (-)
                  <Info info='Soma de todos os pontos negativos que possuem
                  relação com o resgate de um voucher moeda.'/></td>
                  <td className="number-report">{report.data.used_points}</td>
                </tr>
                <tr>
                  <td className="icon-info" > Pontos expirados (-) <Info info="Soma de
                  todos os pontos negativos - Pontos que não foram utilizados e que já foram expirados.
                  A expiração ocorre sempre no dia 1º do ano subsequente."/> </td>
                  <td className="number-report">
                    {report.data.expired_points}
                  </td>
                </tr>
                <tr>
                  <td className="icon-info" >Resgate catálogo (-) <Info info="Pontos utilizados
                  para a troca de produtos e experiências no catálogo de prêmios."/> </td>
                  <td className="number-report">
                    {report.data.negative_points_webpremios}
                  </td>
                </tr>
                <tr>
                  <td className="icon-info" >Outros pontos negativos (-) <Info info="Anulação,
                  devolução, lançamento manual negativo e cancelamento/estorno do catálogo."/> </td>
                  <td className="number-report">
                    {report.data.negative_points}
                  </td>
                </tr>
                <tr>
                  <td className="icon-info" >Pontos disponíveis  <Info info="Soma de todos os pontos
                   (positivos e negativos) até o último período informado."/> </td>
                  <td className="number-report">
                    {report.data.available_points}
                  </td>
                </tr>
                <tr>

                  <td className="icon-info" >Pontos a vencer (no ano corrente) <Info info="

                  Soma dos pontos que irão expirar no ano corrente no caso de não utilização."/> </td>
                  <td className="number-report">
                    {report.data.to_expire_points}
                  </td>
                </tr>
              </tbody>

              <thead>
                <tr>
                  <th>Vouchers(Vale Troca)</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="subSection-report">Vouchers resgatados</td>
                  <td className="number-report">
                    {report.data.total_redeem_vouchers}
                  </td>
                </tr>
                <tr>
                  <td>Vouchers de R$ 10,00 </td>
                  <td className="number-report">
                    {report.data.redeem_voucher_10}
                  </td>
                </tr>
                <tr>
                  <td>Vouchers de R$ 30,00 </td>
                  <td className="number-report">
                    {report.data.redeem_voucher_30}
                  </td>
                </tr>
                <tr>
                  <td>Vouchers de R$ 35,00 </td>
                  <td className="number-report">
                    {report.data.redeem_voucher_35}
                  </td>
                </tr>
                <tr>
                  <td>Vouchers de R$ 75,00 </td>
                  <td className="number-report">
                    {report.data.redeem_voucher_75}
                  </td>
                </tr>
                <tr>
                  <td>Vouchers de R$ 100,00 </td>
                  <td className="number-report">
                    {report.data.redeem_voucher_100}
                  </td>
                </tr>
                <tr>
                  <td>Vouchers de R$ 150,00 </td>
                  <td className="number-report">
                    {report.data.redeem_voucher_150}
                  </td>
                </tr>
                <tr>
                  <td>Vouchers de R$ 175,00 </td>
                  <td className="number-report">
                    {report.data.redeem_voucher_175}
                  </td>
                </tr>
                <tr>
                  <td>Vouchers de R$ 400,00 </td>
                  <td className="number-report">
                    {report.data.redeem_voucher_400}
                  </td>
                </tr>
                <tr>
                  <td>Vouchers de R$ 750,00 </td>
                  <td className="number-report">
                    {report.data.redeem_voucher_750}
                  </td>
                </tr>
                <tr>
                  <td className="subSection-report">Vouchers utilizados </td>
                  <td className="number-report">
                    {report.data.total_used_vouchers}
                  </td>
                </tr>
                <tr>
                  <td>Vouchers de R$ 10,00 </td>
                  <td className="number-report">
                    {report.data.used_voucher_10}
                  </td>
                </tr>
                <tr>
                  <td>Vouchers de R$ 30,00 </td>
                  <td className="number-report">
                    {report.data.used_voucher_30}
                  </td>
                </tr>
                <tr>
                  <td>Vouchers de R$ 35,00 </td>
                  <td className="number-report">
                    {report.data.used_voucher_35}
                  </td>
                </tr>
                <tr>
                  <td>Vouchers de R$ 75,00 </td>
                  <td className="number-report">
                    {report.data.used_voucher_75}
                  </td>
                </tr>
                <tr>
                  <td>Vouchers de R$ 100,00 </td>
                  <td className="number-report">
                    {report.data.used_voucher_100}
                  </td>
                </tr>
                <tr>
                  <td>Vouchers de R$ 150,00 </td>
                  <td className="number-report">
                    {report.data.used_voucher_150}
                  </td>
                </tr>
                <tr>
                  <td>Vouchers de R$ 175,00 </td>
                  <td className="number-report">
                    {report.data.used_voucher_175}
                  </td>
                </tr>
                <tr>
                  <td>Vouchers de R$ 400,00 </td>
                  <td className="number-report">
                    {report.data.used_voucher_400}
                  </td>
                </tr>
                <tr>
                  <td>Vouchers de R$ 750,00 </td>
                  <td className="number-report">
                    {report.data.used_voucher_750}
                  </td>
                </tr>
              </tbody>

              <thead>
                <tr>
                  <th>Clientes</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Clientes que resgataram vouchers</td>
                  <td className="number-report">{report.data.customers}</td>
                </tr>

                <tr>
                  <td>Quantidade média de vouchers resgatados por Cliente</td>
                  <td className="number-report">
                    {report.data.average_redeemed_per_customer}
                  </td>
                </tr>

                <tr>
                  <td>Clientes que utilizaram vouchers</td>
                  <td className="number-report">
                    {report.data.customers_with_used_vouchers}
                  </td>
                </tr>

                <tr>
                  <td>Quantidade média de vouchers utilizados por Cliente</td>
                  <td className="number-report">
                    {report.data.average_used_per_customer}
                  </td>
                </tr>
              </tbody>

              <thead>
                <tr>
                  <th>Ticket Médio</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Ticket médio em compra com voucher</td>
                  <td className="number-report">
                    R$ {report.data.average_ticket}
                  </td>
                </tr>

                <tr>
                  <td>Valor Médio Gasto por Cliente com voucher</td>
                  <td className="number-report">
                    R$ {report.data.average_unique_tickets}
                  </td>
                </tr>

                <tr>
                  <td>Quantidade de Compras com voucher moeda</td>
                  <td className="number-report">
                    {report.data.total_transactions}
                  </td>
                </tr>
              </tbody>
            </table>

            <button
              type="button"
              className="button-submit"
              onClick={this.handleExport}
            >
              Exportar Planilha
            </button>
          </Fragment>
        </Panel>
      </Page>
    );
  }
}

const mapState = (state) => ({
  report: {
    ...state.reports.points,
    data: ReportsSelectors.points(state.reports.points.data),
  },
});

const mapActions = (dispatch) => bindActionCreators(ReportsActions, dispatch);

export default connect(mapState, mapActions)(Benefits);
